var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Watch } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { SystemsClient, SitesClient, CompaniesClient, GetSystemViewPaginatedQuery, PaginatedEnumerableOfSystemQuery, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
import ImportSystemFromZipModal from "@/app/vues/components/import-system-from-zip-modal.vue";
const systemsClient = new SystemsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const maxNumberOfBlocks = 100;
const queryStringHelper = new QueryStringHelper();
let SystemsVue = class SystemsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.showAdvancedFilters = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SystemName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetSystemViewPaginatedQuery({
            companyId: null,
            countryId: null,
            siteId: null,
            city: null,
            keywords: null,
            pageNo: 1,
            pageSize: 25,
            includeDeleted: false,
            showUnhealthyOnly: false,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfSystemQuery();
        // array
        this.companies = [];
        this.sites = [];
        this.cities = [];
        this.columns = [
            { visible: true, fieldName: "systemName", title: "Name" },
            { visible: true, fieldName: "serialNumber", title: "Serial Number" },
            { visible: true, fieldName: "siteName", title: "Site" },
            { visible: true, fieldName: "streetAddress3", title: "City" },
            { visible: true, fieldName: "companyName", title: "Company" }
        ];
    }
    // methods
    created() {
        this.loadDataGridState();
        this.getLookups();
    }
    ;
    mounted() {
    }
    ;
    // get
    getLookups() {
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `Any company` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            // set values from query string.
            this.working = true;
            if (queryStringHelper.hasParameter("keywords")) {
                queryStringHelper.setFromQueryString("keywords", null, (value) => {
                    this.query.keywords = value;
                    return this.query.keywords;
                });
            }
            if (queryStringHelper.hasParameter("companyId")) {
                queryStringHelper.setFromQueryString("companyId", null, (value) => {
                    this.query.companyId = value && parseInt(value) ? parseInt(value) : null;
                    return this.query.companyId;
                });
            }
            if (queryStringHelper.hasParameter("siteId")) {
                queryStringHelper.setFromQueryString("siteId", null, (value) => {
                    this.query.siteId = value && parseInt(value) ? parseInt(value) : null;
                    return this.query.siteId;
                });
            }
            if (queryStringHelper.hasParameter("city")) {
                queryStringHelper.setFromQueryString("city", null, (value) => {
                    this.query.city = value ? value : null;
                    return this.query.city;
                });
            }
            if (queryStringHelper.hasParameter("includeDeleted")) {
                queryStringHelper.setFromQueryString("city", null, (value) => {
                    this.query.includeDeleted = value && value == "true" ? true : false;
                    return this.query.includeDeleted;
                });
            }
            // once set, re-query the form.
            this.working = false;
            this.search();
        });
    }
    ;
    onCompanyIdChanged() {
        this.siteId = this.filteredSites[0];
        this.city = this.filteredCities[0];
        this.search();
    }
    onSiteIdChanged() {
        this.city = this.filteredCities[0];
        this.search();
    }
    search() {
        if (this.working)
            return;
        this.working = true;
        systemsClient
            .search(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
            let params = [
                { value: this.query.keywords, parameterName: "keywords" },
                { value: this.query.companyId, parameterName: "companyId" },
                { value: this.query.siteId, parameterName: "siteId" },
                { value: this.query.city, parameterName: "city" },
                { value: this.query.includeDeleted, parameterName: "includeDeleted" }
            ];
            queryStringHelper.updateQueryStrings(params);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("systems-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    // set
    edit(system) {
        this.$router.push({ name: RouteNames.System, params: { id: system.systemId.toString() } });
    }
    ;
    archive(system) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this system?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            systemsClient
                .delete(system.systemId)
                .then(() => {
                system.whenDeleted = new Date();
                Notifier.onOk(`System # ${system.systemId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(system) {
        if (this.working)
            return;
        systemsClient
            .restore(system.systemId)
            .then(() => {
            system.whenDeleted = undefined;
            Notifier.onOk(`System # ${system.systemId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    toggleAdvancedFilterPanel() {
        this.showAdvancedFilters = !this.showAdvancedFilters;
    }
    ;
    selectColumn(column) {
        this.ensureOneColumnSelected(!column.visible, column);
    }
    ;
    ensureOneColumnSelected(checked, column) {
        if (this.numberOfVisibleColumns <= 1) {
            column.visible = true;
            return;
        }
        column.visible = checked;
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    showImportModal() {
        const modal = this.$refs.importModal;
        if (modal) {
            modal.showModal();
        }
    }
    ;
    onImportCompleted(result) {
        // Refresh the systems list after successful import
        if (result && result.success) {
            this.search();
        }
    }
    ;
    // computed
    get filteredSites() {
        let sites = (this.sites || [])
            .filter(site => { var _a; return ((_a = this.companyId) === null || _a === void 0 ? void 0 : _a.value) == null || site.companyId == this.companyId.value; });
        let mappedSites = sites.map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        return [{ value: null, text: `Any site` }].concat(mappedSites);
    }
    get filteredCities() {
        var _a;
        let siteIds = ((_a = this.siteId) === null || _a === void 0 ? void 0 : _a.value) != null ? [this.siteId.value] : this.filteredSites.filter(item => item.value).map(item => item.value);
        let sites = this.sites.filter(item => siteIds.includes(item.siteId));
        let cities = Array.from(new Set((sites || []).filter(item => {
            return item.address && item.address.streetAddress3;
        }).map(item => {
            return item.address ? item.address.streetAddress3 : "";
        }))).sort()
            .map(item => {
            return {
                value: item,
                text: item
            };
        });
        cities = [{ value: null, text: `Any city` }].concat(cities).map(item => {
            return {
                value: item.value,
                text: item.text
            };
        });
        return cities;
    }
    getCriticalBlocksBadge(system) {
        return `${TextHelper.formatNumericStatusField(system.numberOfCriticalBlocks || 0, maxNumberOfBlocks)} critical`;
    }
    ;
    getWarningBlocksBadge(system) {
        return `${TextHelper.formatNumericStatusField(system.numberOfWarningBlocks || 0, maxNumberOfBlocks)} warned`;
    }
    ;
    getHealthyBlocksBadge(system) {
        let total = system.numberOfBlocks || 0;
        let critical = system.numberOfCriticalBlocks || 0;
        let warned = system.numberOfWarningBlocks || 0;
        let healthy = total - (critical + warned);
        return `${TextHelper.formatNumericStatusField(healthy, maxNumberOfBlocks)} healthy`;
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get isClientAdministrator() {
        return this.loginState.isClientAdministrator;
    }
    ;
    get companyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set companyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get siteId() {
        return this.filteredSites.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get city() {
        return this.filteredCities.filter(item => {
            return item.value == this.query.city;
        })[0] || null;
    }
    ;
    set city(item) {
        if (!item)
            return;
        this.query.city = item.value;
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("systems-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], SystemsVue.prototype, "loginState", void 0);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemsVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemsVue.prototype, "onSiteIdChanged", null);
__decorate([
    Watch("query.city"),
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemsVue.prototype, "search", null);
__decorate([
    Watch("query.includeDeleted"),
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemsVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemsVue.prototype, "onSortChanged", null);
SystemsVue = __decorate([
    Component({
        name: "SystemsVue",
        components: {
            ImportSystemFromZipModal
        }
    })
], SystemsVue);
export default SystemsVue;
